<template>
  <sf-calculator-tabs v-if="limit !== 'first'" class="calculator-tabs">
    <template slot="first">
      <span>{{ $t('calculator.first') }}</span>
      <span class="mob_hide">&nbsp;{{ $t('calculator.loan') }}</span>
    </template>
    <template slot="repeated">
      <span>{{ $t('calculator.repeated') }}</span>
      <span class="mob_hide">&nbsp;{{ $t('calculator.loan') }}</span>
    </template>
  </sf-calculator-tabs>
</template>

<script>
export default {
  name: 'CalculatorTabs',
  props: {
    limit: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.calculator-tabs {
  color: map-get($colors, gray-darker) !important;

  /deep/ .calculator__tab {
    border-radius: 10px 10px 0 0;
    font-size: 14px;

    &.active {
      background: map-get($colors, white);
    }

    &:not(.active) {
      font-weight: 400;
    }
  }
}
</style>
